import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { KTSVG } from '../../../_metronic/helpers'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import Select, { StylesConfig } from 'react-select';
import { expensePolicyPerDiemInitialsForAdd, expensePolicyPerDiemInitialsForUpdate } from './interfaces/expensePolicyPerDiemClass';
import {
    addDefaultCategoryAsync, UpdateDefaultCategoryAsync, addPerDiemLocationsAsync, addPerDiemLocationRatesAsync,
    UpdatePerDiemLocationsAsync, UpdatePerDiemLocationRatesAsync, setValuesAccountExpensePolicyPerDiemRate,
    setValuesPerDiemLocationCountryIdCityId, UpdateAccountExpensePolicyPerDiemLocationId, UpdateAccountExpensePolicyPerDiemLocationRateId,
    resetAccountExpensePolicyperDiemId, GetAccountExpensePolicyPerDiemRateForAddEditLocationRateAsync,
    GetDataForPerdiemTypesListForAddLocationRatesAsync, updateForDefaultRate, resetSelectedRecordObjectInState, GetDataForExpensePolicyPerDiemRateAsync
} from './expensePolicyPerDiemSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import fetchAPI from '../../../common/fetchAPI';
import moment from 'moment';
import * as yup from 'yup';
import { ShowSwal, ShowSwalForCanvas } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { useFormik } from 'formik';
import { isVisibleElement } from '../../../_metronic/assets/ts/_utils';
import { AnyMxRecord } from 'dns';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import { useTranslation } from 'react-i18next';
import CanvasLoader from '../../../common/CanvasLoader';
import { dropDownSelectionStyles, dateFormatByAccountCulture , getValueFromResource, formatNumberCustomoriginalapiv2, determineCommaSeprater} from '../../../common/timeLiveFunction';


interface SelectedCurrencyValues {
    [key: number]: number;
}

const ExpensePolicyPerDiemForm = (props: any) => {
    const { modelRef, buttonId, filteredArray, handleOnClickLocationRateEvent } = props;
    const { t } = useTranslation();
    const { sessionAccountEmployeeId, accountBaseCurrencyId, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat , calendarStartDay} = useAppSelector((state) => state.globalState);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expensePolicyPerDiemInitialsForAdd);
    const { expensePolicyPerDiemTypeList, AccountExpensePolicyPerDiemId, expensePolicyPerDiemDetailList,
        AccountExpensePolicyPerDiemLocationId, isReload, selectedRecord, ForDefaultRate, DefaultExpenseCatId,
        AccountExpensePolicyPerDiemLocationRateId, AccountExpensePolicyPerDiemLocationId1, isLoading, isListUpdated } = useAppSelector((state) => state.expensePolicyPerDiem);
    const { maxMenuHeight,decimalPlaces } = useAppSelector((state) => state.globalState);
    const { MasterExpensePolicyId } = useAppSelector((state) => state.expensePolicy);
    const [selectexpensePolicyPerDiemTypeList, setexpensePolicyPerDiemTypeList] = useState<any>(expensePolicyPerDiemInitialsForAdd);
    const [selectedOptionCurrency, setselectedOptionCurrency] = useState<{ [object: string]: any }>();
    const [currencyArray, SetCurrencyArray] = useState<any | ''>([]);
    const [selectedOptionCountry, setselectedOptionCountry] = useState<{ [object: string]: any }>();
    const [countryArray, SetCountryArray] = useState<any | ''>([]);
    const [selectedOptionCity, setselectedOptionCity] = useState<{ [object: string]: any }>();
    const [cityArray, SetCityArray] = useState<any | ''>([]);
    const navigate = useNavigate();  
    const location = useLocation();
    const { obj } = location.state || {};    
    const storedObjectData = localStorage.getItem('objExpensePolicyItem');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
    const [editingValues, setEditingValues] = useState<{ [id: number]: string }>({});
    let AccountExpensePolicyId = '00000000-0000-0000-0000-000000000000';
     if (MasterExpensePolicyId && MasterExpensePolicyId !== '') {
        AccountExpensePolicyId = MasterExpensePolicyId;
     } else if (obj && obj.AccountExpensePolicyId) {
        AccountExpensePolicyId = obj.AccountExpensePolicyId;
     } else if(objectData && objectData.AccountExpensePolicyId){
        AccountExpensePolicyId = objectData.AccountExpensePolicyId;
     }else
     {
         navigate('../expensepolicy');
     }

    const dispatch = useAppDispatch();
    const currentDate = new Date();
    const [isTextBoxEnabled, setIsTextBoxEnabled] = useState(true);
    const [isDatePickerEnabled, setIsDatePickerEnabled] = useState(true);
    const LocationName = 'Default Rate'
    const [rows, setRows] = useState([]);
    const [inputValue, setInputValue] = useState(expensePolicyPerDiemDetailList);
    const [records, setRecords] = useState([]);
    const [forceRender, setForceRender] = useState(false);
    const isDropdownVisible = true;
    const [text, settest] = useState(true);
    const [selectedCurrencyValues, setSelectedCurrencyValues] = useState<SelectedCurrencyValues>({});
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);
    const enableTextBox = () => {
        setIsTextBoxEnabled(true);
    };
    const formik = useFormik({
        initialValues: {
            ...currentFieldsData,
            AccountExpensePolicyId: AccountExpensePolicyId,
            SystemCountryId: selectedOptionCountry?.value || "",
            SystemCityId: selectedOptionCity?.value || "",
            SystemCurrencyId: selectedOptionCurrency?.value || "",
            ForDefaultRate
        },
        enableReinitialize: true,

        validationSchema: yup.object().shape({

            SystemCountryId: yup.string().when('ForDefaultRate', ([ForDefaultRate], schema) => {

                if (!ForDefaultRate)
                    return yup.string().
                required
                // (t('Country is required'));
                (getValueFromResource('Country is required',dispatch, t));
                return schema;
            }),
            SystemCityId: yup.string().when('ForDefaultRate', ([ForDefaultRate], schema) => {

                if (!ForDefaultRate)
                    return yup.string().required
                // (t('City is required'));
                (getValueFromResource('City is required',dispatch, t));
                return schema;
            }),
        }),
        onSubmit: (values, action) => {

            handleSubmit(values);
            action.resetForm();
        },
    });


    const getCurrenciesAsync = async () => {
        const response = await fetchAPI("api/Currencies/RateCurrency", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.AccountCurrencyId;
            item.label = item.CurrencyCode;
            delete item.AccountCurrencyId;
            delete item.CurrencyCode;
        });
        SetCurrencyArray(json);
    }

    const getCountryAsync = async () => {
        const response = await fetchAPI("api/ExpensePolicies/GetCountry", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.CountryId;
            item.label = item.Country;
            delete item.CountryId;
            delete item.Country;
        });
        SetCountryArray(json);

    }
    const getCitiesByCountryIdAsync = async (value: any) => {
        const response = await fetchAPI("api/ExpensePolicies/GetCitiesByCountryId/" + value, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.CityId;
            item.label = item.City;
            delete item.CityId;
            delete item.City;
        });
        SetCityArray(json);
    }

    useEffect(() => {
        getCurrenciesAsync();
        getCountryAsync();
        setIsCanvasLoader(false);


    }, [isReload, AccountExpensePolicyPerDiemLocationId])


    useEffect(() => {

        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {

            const tempObj: any = selectedRecord;

            Object.keys(expensePolicyPerDiemInitialsForUpdate).map((item) => {

                if (stateItem.SystemCountryId > 0) {
                    dispatch(updateForDefaultRate(false));
                    return stateItem[item] = tempObj[item];
                }
                else {
                    dispatch(updateForDefaultRate(true));
                    return stateItem[item] = tempObj[item];
                }
            })
            setIsTextBoxEnabled(false);
            setIsDatePickerEnabled(false);
            // stateItem.EffectiveDate = new Date(stateItem.EffectiveDate);
            stateItem.EffectiveDate = dateFormatByAccountCulture(stateItem.EffectiveDate, cultureInfoName.toString());
            setCurrentFieldsData(stateItem);
            // setselectedOptionCurrency({ value:tempObj.SystemCurrencyId, label:stateItem.CurrencyCode });
            setSelectedCurrencyValues((prevState: any) => ({
                ...prevState,
                [stateItem.AccountExpensePolicyPerDiemTypeId]: tempObj.SystemCurrencyId,
            }));
            setselectedOptionCountry({ value: tempObj.SystemCountryId, label: stateItem.Country });
            if (tempObj.SystemCountryId > 0) {
                getCitiesByCountryIdAsync(tempObj.SystemCountryId);
                setselectedOptionCity({ value: tempObj.SystemCityId, label: stateItem.City });
            }
            dispatch(UpdateAccountExpensePolicyPerDiemLocationId(stateItem.AccountExpensePolicyPerDiemLocationId));
            dispatch(UpdateAccountExpensePolicyPerDiemLocationRateId(stateItem.AccountExpensePolicyPerDiemLocationRateId));
            setIsCanvasLoader(false);
        }
        else {
            setIsTextBoxEnabled(true);
            setIsDatePickerEnabled(true);
            setCurrentFieldsData(expensePolicyPerDiemInitialsForAdd);
            setselectedOptionCountry({ value: 0, label: 'Select' });
            getCitiesByCountryIdAsync(0);
            setselectedOptionCity({ value: 0, label: 'Select' });
            formik.resetForm();

        }
    }, [selectedRecord])

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const AddUpdatePerDiemLocationAndRatesData = async (PerDiemId: any) => {

        if (ForDefaultRate == true) {
            if (AccountExpensePolicyPerDiemLocationId > 0) {
                dispatch(UpdatePerDiemLocationsAsync({ ...currentFieldsData, 'AccountExpensePolicyPerDiemLocationId': AccountExpensePolicyPerDiemLocationId, 
                    'AccountExpensePolicyPerDiemId': PerDiemId, 'PerDiemLocationName': 'Default Rate', 'CountryId': '0', 'CityId': '0'
                    , 'IsDefaultRate': true, 'EffectiveDate': moment(currentFieldsData.EffectiveDate).format(dateInsertionFormat) }))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        ShowToast("Default Location Update Successfully", 'Success', "success", "toast-top-right");
                        if (AccountExpensePolicyPerDiemLocationRateId > 0) {
                            dispatch(UpdatePerDiemLocationRatesAsync(expensePolicyPerDiemTypeList))
                                .then((originalPromiseResult) => {
                                    ShowToast("Default Location Rates Update Successfully", 'Success', "success", "toast-top-right");
                                    dispatch(GetDataForExpensePolicyPerDiemRateAsync(AccountExpensePolicyId));
                                })
                        }
                        else {
                            var DefaultRateAddArray: Array<any>
                            DefaultRateAddArray = expensePolicyPerDiemTypeList
                            const getDefaultRateAddArray = DefaultRateAddArray.map((item: any) => ({
                                ...item,
                                AccountExpensePolicyPerDiemLocationId: AccountExpensePolicyPerDiemLocationId,
                            }));
                            dispatch(addPerDiemLocationRatesAsync(getDefaultRateAddArray))
                                .then((originalPromiseResult) => {
                                    ShowToast("Default Location Rates Add Successfully", 'Success', "success", "toast-top-right");
                                    dispatch(GetDataForExpensePolicyPerDiemRateAsync(AccountExpensePolicyId));
                                })
                        }
                    })
            } else {
                dispatch(addPerDiemLocationsAsync({ ...currentFieldsData, 'AccountExpensePolicyPerDiemId': PerDiemId, 'PerDiemLocationName': 'Default Rate', 'CountryId': '0', 'CityId': '0', 'IsDefaultRate': true, 'EffectiveDate': moment(currentFieldsData.EffectiveDate).format(dateInsertionFormat) }))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        ShowToast("Default Location Add Successfully", 'Success', "success", "toast-top-right");
                        var tempDefaultRateArray: Array<any>
                        tempDefaultRateArray = expensePolicyPerDiemTypeList
                        const getDefaultRateArray = tempDefaultRateArray.map((item: any) => ({
                            ...item,
                            AccountExpensePolicyPerDiemLocationId: Number(originalPromiseResult.id),
                        }));
                        dispatch(addPerDiemLocationRatesAsync(getDefaultRateArray))
                            .then((originalPromiseResult) => {
                                ShowToast("Default Location Rates Updated Successfully", 'Success', "success", "toast-top-right");
                                dispatch(GetDataForExpensePolicyPerDiemRateAsync(AccountExpensePolicyId));
                            })
                    })
            }
        }
        else {
            const ddlCity = { value: selectedOptionCity };
            const ddlCountry = { value: selectedOptionCountry };
            const { PerDiemLocationName } = currentFieldsData;
            if (AccountExpensePolicyPerDiemLocationId > 0) {
                dispatch(UpdatePerDiemLocationsAsync({ ...currentFieldsData, 'AccountExpensePolicyPerDiemLocationId': AccountExpensePolicyPerDiemLocationId, 'AccountExpensePolicyPerDiemId': PerDiemId, 'PerDiemLocationName': PerDiemLocationName, 'SystemCountryId': ddlCountry, 'SystemCityId': ddlCity, 'IsDefaultRate': false }))
                    .unwrap()
                    .then((originalPromiseResult) =>  {
                        //ShowToast("Per Diem Location Update Successfully", 'Success', "success", "toast-top-right");
                        if (AccountExpensePolicyPerDiemLocationRateId > 0) {
                            var tempLocationRateArray: Array<any>
                            tempLocationRateArray = expensePolicyPerDiemTypeList
                            const getLocationRateUpdateArray = tempLocationRateArray.map((item: any) => ({
                                ...item,
                                AccountExpensePolicyPerDiemLocationId: AccountExpensePolicyPerDiemLocationRateId,

                            }));
                            dispatch(UpdatePerDiemLocationRatesAsync(getLocationRateUpdateArray))
                                .then((originalPromiseResult) => {
                                    ShowToast("Per Diem Location Rates Update Successfully", 'Success', "success", "toast-top-right");
                                    dispatch(GetDataForExpensePolicyPerDiemRateAsync(AccountExpensePolicyId));
                                })
                        }
                        else {
                            var LocationRateArray: Array<any>
                            LocationRateArray = expensePolicyPerDiemTypeList
                            const getLocationRateAddArray = LocationRateArray.map((item: any) => ({
                                ...item,
                                AccountExpensePolicyPerDiemLocationId: AccountExpensePolicyPerDiemLocationId,
                            }));

                            dispatch(addPerDiemLocationRatesAsync(getLocationRateAddArray))
                                .then((originalPromiseResult) => {
                                    ShowToast("Per Diem Location Rates Add Successfully", 'Success', "success", "toast-top-right");
                                    dispatch(GetDataForExpensePolicyPerDiemRateAsync(AccountExpensePolicyId));
                                })

                        }
                    })

            } else {
                dispatch(addPerDiemLocationsAsync({ ...currentFieldsData, 'AccountExpensePolicyPerDiemId': PerDiemId, 'PerDiemLocationName': PerDiemLocationName, 'SystemCountryId': ddlCountry, 'SystemCityId': ddlCity, 'IsDefaultRate': false, 'EffectiveDate': moment(currentFieldsData.EffectiveDate).format(dateInsertionFormat) }))
                    .unwrap()
                    .then((originalPromiseResult: any) => {
                        //ShowToast("Per Diem Location Add Successfully", 'Success', "success", "toast-top-right");
                        var tempLocationRateArray: Array<any>
                        tempLocationRateArray = expensePolicyPerDiemTypeList
                        const getLocationRateArray = tempLocationRateArray.map((item: any) => ({
                            ...item,
                            AccountExpensePolicyPerDiemLocationId: Number(originalPromiseResult.id), // just for example
                        }));
                        dispatch(addPerDiemLocationRatesAsync(getLocationRateArray))
                            .then((originalPromiseResult) => {
                                ShowToast("Per Diem Location & Rates Add Successfully", 'Success', "success", "toast-top-right");
                                dispatch(GetDataForExpensePolicyPerDiemRateAsync(AccountExpensePolicyId));
                            })
                    })
            }
        }

    }

    const InsertPerDiemDefautCategoryData = async () => {
        const response = await fetchAPI('api/ExpensePolicies/GetAccountExpensePolicyPerDiemId/' + AccountExpensePolicyId, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        if (json.length > 0) {
            dispatch(UpdateDefaultCategoryAsync({ ...currentFieldsData, 'AccountExpensePolicyPerDiemId': json[0].AccountExpensePolicyPerDiemId, 'AccountExpensePolicyId': AccountExpensePolicyId, 'DefaultExpenseCategoryPerDiemId': DefaultExpenseCatId }));
            //ShowToast("Default Category Update Successfully", 'Success', "success", "toast-top-right");
            dispatch(resetAccountExpensePolicyperDiemId(json[0].AccountExpensePolicyPerDiemId));
            AddUpdatePerDiemLocationAndRatesData(json[0].AccountExpensePolicyPerDiemId);

        } else {
            dispatch(addDefaultCategoryAsync({ ...currentFieldsData, 'AccountExpensePolicyId': AccountExpensePolicyId, 'DefaultExpenseCategoryPerDiemId': DefaultExpenseCatId }))
                .unwrap()
                .then((result) => {
                    ShowToast("Default Category Add Successfully", 'Success', "success", "toast-top-right");
                    const ExpensePerDiemId = result.id;
                    AddUpdatePerDiemLocationAndRatesData(ExpensePerDiemId);
                    dispatch(resetAccountExpensePolicyperDiemId(ExpensePerDiemId));

                })
                .catch((error) => {
                    console.log('handleSubmit-addDefaultCategoryAsync-rejectedValueOrSerializedError', error);
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }

    }

const parsePerDiemRate = (value: string | number, locale: string) => {
  if (value === null || value === undefined) return 0;

  const isComma = determineCommaSeprater(locale);

  // Ensure it's a string for replace
  const strValue = value.toString();

  const normalized = isComma ? strValue.replace(",", ".") : strValue;

  const numberValue = Number(normalized);
  return isNaN(numberValue) ? 0 : numberValue;
};



    const handleSubmit = (e: any) => {

        // const hasValidPerDiemRate = expensePolicyPerDiemTypeList.some(item => item.PerDiemRate > 0);
      const hasValidPerDiemRate = expensePolicyPerDiemTypeList.some(item =>
  parsePerDiemRate(item.PerDiemRate, cultureInfoName.toString()) > 0
);

        console.log('hasValidPerDiemRate',hasValidPerDiemRate)

        if (!hasValidPerDiemRate) {
            ShowSwalForCanvas('PER DIEM RATE', 'Please fill the Currency corresponding Per Diem Rate', 'warning');
            return;
        }


        // let hasCurrencyIdGreaterThanZero = false;       
        // for (let i = 0; i < expensePolicyPerDiemTypeList.length; i++) {
        //     const item = expensePolicyPerDiemTypeList[i];
        //     if (item.SystemCurrencyId > 0) {

        //         hasCurrencyIdGreaterThanZero = true;
        //         if (item.PerDiemRate <= 0) {
        //             ShowSwalForCanvas('PER DIEM RATE', 'Please fill the Currency corresponding Per Diem Rate', 'warning');
        //             return;
        //         }
        //     }
        // }

        // if (!hasCurrencyIdGreaterThanZero) {
        //     ShowSwalForCanvas('PER DIEM CURRENCY', 'Please make sure to select at least 1 Per Diem Currency', 'warning');
        //     return;
        // }

        InsertPerDiemDefautCategoryData();
    }

    const handleDateChange = (date: Date) => {
        setCurrentFieldsData({ ...currentFieldsData, 'EffectiveDate': date });
    };


    const handleChangeCountry = (data: any) => {

        const { value, label } = data;
        setselectedOptionCountry({ value: value, label: label });
        setCurrentFieldsData({ ...currentFieldsData, 'CountryId': value, 'PerDiemLocationName': label });
        getCitiesByCountryIdAsync(value);
        setselectedOptionCity({ value: 0, label: 'Select' });
    };

    const handleChangeCity = (data: any) => {
        const { value, label } = data;
        setselectedOptionCity({ value: value, label: label });
        const { PerDiemLocationName } = currentFieldsData;
        setCurrentFieldsData({ ...currentFieldsData, 'CityId': value, 'PerDiemLocationName': PerDiemLocationName.split('-')[0] + '-' + label });
        dispatch(GetDataForPerdiemTypesListForAddLocationRatesAsync({ "AccountExpensePolicyId": AccountExpensePolicyId, "CountryId": data.CountryId, "CityId": value, "AccountExpensePolicyPerDiemLocationRateId": AccountExpensePolicyPerDiemLocationRateId }));

        const defaultitem = expensePolicyPerDiemDetailList.find(item => item.SystemCountryId === data.CountryId && item.SystemCityId === value);
        const LocationId = defaultitem ? defaultitem.AccountExpensePolicyPerDiemLocationId : null;
        dispatch(UpdateAccountExpensePolicyPerDiemLocationId(LocationId == null ? 0 : LocationId));
    };


    // const handleRateChange = (e: any, accountExpensePolicyPerDiemTypeId: any) => {
      
    //      dispatch(setValuesAccountExpensePolicyPerDiemRate({ "Id": accountExpensePolicyPerDiemTypeId, "PerDiemRate": e.target.value }));
    // };
const handleRateChange = (e: any, id: number) => {
  let value = e.target.value;
  const isComma = determineCommaSeprater(cultureInfoName.toString());

  // Allow only digits + decimal separator
  if (isComma) {
    value = value.replace(/[^0-9,]/g, "");
    const parts = value.split(",");
    if (parts.length > 2) value = parts[0] + "," + parts[1];
  } else {
    value = value.replace(/[^0-9.]/g, "");
    const parts = value.split(".");
    if (parts.length > 2) value = parts[0] + "." + parts[1];
  }

  // Save temporary typing value
  setEditingValues(prev => ({
    ...prev,
    [id]: value
  }));
};



const handleRateBlur = (e: any, id: number) => {
  const value = e.target.value;
  const isComma = determineCommaSeprater(cultureInfoName.toString());

  // Convert string to number
  const numberValue = isComma ? Number(value.replace(",", ".")) : Number(value);

  // Redux update with number
  dispatch(setValuesAccountExpensePolicyPerDiemRate({
    Id: id,
    PerDiemRate: numberValue
  }));

  // Clear temp typing
  setEditingValues(prev => {
    const copy = { ...prev };
    delete copy[id];
    return copy;
  });
};



    const handlecurrencychange = (e: any, AccountExpensePolicyPerDiemTypeId: any) => {
        setSelectedCurrencyValues((prevState: any) => ({
            ...prevState,
            [AccountExpensePolicyPerDiemTypeId]: e.value,
        }));
        dispatch(setValuesAccountExpensePolicyPerDiemRate({ "Id": AccountExpensePolicyPerDiemTypeId, "SystemCurrencyId": e.value, "CurrencyCode": e.label }));

        if (Object.keys(selectedRecord).length > 0) {
            setselectedOptionCurrency({ value: e.value, label: e.label });
        }
    };
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }

    return (
        <>
            <div className='card-body'>
                {/* {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <> */}
                {isCanvasLoader ? <CanvasLoader /> : <>
                        {ForDefaultRate == false ? (<>
                               {/* <div className="row" id="divCountryCity">
                                <div className="col-md-6">
                                    <label className="fs-7 fw-normal mb-2">{t('Country')}</label>
                                    <Select
                                        value={formik.values.SystemCountryId != "" ? countryArray.find((option: any) => option.value == formik.values.SystemCountryId) : ""}
                                        id="SystemCountryId"
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        name="SystemCountryId"
                                        onBlur={() => formik.setFieldTouched('SystemCountryId', true)}
                                        onChange={(selectedOptionCountry) => {
                                            formik.handleChange({
                                                target: {
                                                    id: "SystemCountryId",
                                                    value: selectedOptionCountry?.value
                                                },
                                            });
                                            handleChangeCountry(selectedOptionCountry);
                                        }}
                                        options={countryArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        isDisabled={!isTextBoxEnabled}
                                    />
                                    <div style={{ paddingRight: 20 }}>
                                        {formik.touched.SystemCountryId && formik.errors.SystemCountryId &&
                                            <p className='errorMsg'>{formik.errors.SystemCountryId as string}</p>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="fs-7 fw-normal mb-2">{t('City')}</label>

                                    <Select
                                        value={formik.values.SystemCityId != "" ? cityArray.find((option: any) => option.value == formik.values.SystemCityId) : ""}
                                        id="SystemCityId"
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        name="SystemCityId"
                                        onBlur={() => formik.setFieldTouched('SystemCityId', true)}
                                        onChange={(selectedOption) => {
                                            formik.handleChange({
                                                target: {
                                                    id: "SystemCityId",
                                                    value: selectedOption?.value
                                                },
                                            });
                                            handleChangeCity(selectedOption);
                                        }}
                                        options={cityArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        isDisabled={!isTextBoxEnabled}
                                    />
                                    <div style={{ paddingRight: 20 }}>
                                        {formik.touched.SystemCityId && formik.errors.SystemCityId &&
                                            <p className='errorMsg'>{formik.errors.SystemCityId as string}</p>
                                        }
                                    </div>
                                </div>
                            </div>' */}

                            <div className='row' id="divCountryCity">
                                <div className="col-md-6">
                                    <label className="form-label fs-7 fw-normal mb-2">
                                        {/* {t('Country')} */}
                                        {getValueFromResource('Country',dispatch, t)}
                                        </label>
                                    <Select
                                        value={formik.values.SystemCountryId != "" ? countryArray.find((option: any) => option.value == formik.values.SystemCountryId) : ""}
                                        className="basic-single fs-7 fw-normal"
                                        classNamePrefix="select"
                                        name="timesheetApprovalTypeArray"
                                        onChange={(selectedOptionCountry) => {
                                            formik.handleChange({
                                                target: {
                                                    id: "SystemCountryId",
                                                    value: selectedOptionCountry?.value
                                                },
                                            });
                                            handleChangeCountry(selectedOptionCountry);
                                        }}
                                        options={countryArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        isDisabled={!isTextBoxEnabled}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fs-7 fw-normal mb-2">
                                        {/* {t('City')} */}
                                        {getValueFromResource('City',dispatch, t)}
                                        </label>
                                    <Select
                                        value={formik.values.SystemCityId != "" ? cityArray.find((option: any) => option.value == formik.values.SystemCityId) : ""}
                                        className="basic-single fs-7 fw-normal"
                                        classNamePrefix="select"
                                        name="expenseApprovalTypeArray"
                                        onChange={(selectedOption) => {
                                            formik.handleChange({
                                                target: {
                                                    id: "SystemCityId",
                                                    value: selectedOption?.value
                                                },
                                            });
                                            handleChangeCity(selectedOption);
                                        }}
                                        options={cityArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        isDisabled={!isTextBoxEnabled}
                                    />
                                    <div style={{ paddingRight: 20 }}>
                                        {formik.touched.SystemCityId && formik.errors.SystemCityId &&
                                            <p className='errorMsg'>{formik.errors.SystemCityId as string}</p>
                                        }
                                    </div>
                                </div>
                            </div>

                        </>
                        ) : null}

                    
                    <div className='row mt-4 mb-3'>
                        <div className="col-md-6">
                            <label className="fs-7 fw-normal mb-2">
                                {/* {t('Location Name')} */}
                                {getValueFromResource('Location Name',dispatch, t)}
                                </label>
                            <input type="text" disabled={!isTextBoxEnabled} className="form-control fs-7 fw-normal" id='PerDiemLocationName'

                                value={ForDefaultRate == true ? 'Default Rate' : formik.values.PerDiemLocationName} name='PerDiemLocationName' />

                        </div>

                        {/* <div className="col-md-6" style={{ paddingLeft: '3px' }}>
                            <label className="fs-7 fw-  normal mb-2">{t('Effective Date')}</label>
                            <DatePicker
                                selected={formik.values.EffectiveDate}
                                onChange={handleDateChange}
                                dateFormat="dd/MM/yyyy"
                                className="form-control form-con fs-7 fw-normal dataPicker input-h ps-4 form-control-dark btn-icon-dark btn-text-dark"
                                disabled={!isDatePickerEnabled}
                            />
                        </div> */}
                         <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Effective Date')} */}
                                                    {getValueFromResource('Effective Date',dispatch, t)}
                                                    </label>
                                                <div className="wrapper">
                                                    <DatePicker
                                                        selected={formik.values.EffectiveDate}
                                                        onChange={handleDateChange}
                                                        //  dateFormat="dd/MM/yyyy"
                                                        calendarStartDay={calendarStartDay}
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                        className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                        disabled={!isDatePickerEnabled}
                                                    >
                                                    </DatePicker>
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                    
                                                </div>
                                            </div>

                    </div>

                    <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" style={{ overflow: 'auto' }}>
                        <thead>
                            <tr className="thHeading align-middle">
                                <th className='w-55px'>
                                    {/* {t('Per Diem Type')} */}
                                    {getValueFromResource('Per Diem Type',dispatch, t)}
                                    </th>
                                <th className='w-25px'>
                                    {/* {t('Per Diem Currency')} */}
                                    {getValueFromResource('Per Diem Currency',dispatch, t)}
                                    </th>
                                <th className='w-20px'>
                                    {/* {t('Per Diem Rate')} */}
                                    {getValueFromResource('Per Diem Rate',dispatch, t)}
                                    </th>
                            </tr>
                        </thead>
                        <tbody>
                            {expensePolicyPerDiemTypeList.map(item =>
                            (
                                <tr key={item.AccountExpensePolicyPerDiemTypeId}>
                                    <td>{item.AccountExpensePolicyPerDiemTypeName}</td>
                                    <td>
                                        <Select
                                            id={`SystemCurrencyId-${item.AccountExpensePolicyPerDiemTypeId}`}
                                            value={currencyArray.find((option: any) => option.value === (selectedCurrencyValues[item.AccountExpensePolicyPerDiemTypeId] || accountBaseCurrencyId))}
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isSearchable={true}
                                            name="SystemCurrencyId"
                                            onChange={selectedOption => handlecurrencychange(selectedOption, item.AccountExpensePolicyPerDiemTypeId)}
                                            options={currencyArray}
                                            styles={dropDownSelectionStyles}
                                            maxMenuHeight={maxMenuHeight}
                                        />
                                    </td>
                                    <td >
                                        {/* <input style={{ textAlign: 'right', height: '41px' }} 
                                    type="text" id="PerDiemRate" 
                                    value={item.PerDiemRate}
                                    //  value={formatNumberCustomoriginalapiv2(cultureInfoName.toString(), Number(item.PerDiemRate), decimalPlaces)}
                                        className="form-control fs-7 fw-normal" onChange={(e) => handleRateChange(e, item.AccountExpensePolicyPerDiemTypeId)} /> */}
                                        <input
  type="text"
  style={{ textAlign: 'right', height: '41px' }}
  value={editingValues[item.AccountExpensePolicyPerDiemTypeId] ?? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), Number(item.PerDiemRate), decimalPlaces)} // local typing value ya redux value
  onChange={(e) => handleRateChange(e, item.AccountExpensePolicyPerDiemTypeId)}
  onBlur={(e) => handleRateBlur(e, item.AccountExpensePolicyPerDiemTypeId)}
  className="form-control fs-7 fw-normal"
/>
                                        
                                        </td>
                                </tr>
                            )
                            )}
                        </tbody>
                    </table>
                    {/* </>
                                } */}
                </>
                }
                 {Object.keys(formik.errors).length > 0 && (
                        <div className="mt-3 alert alert-danger">
                            <strong>
                                {/* {t('Error Summary')}: */}
                                {getValueFromResource('Error Summary',dispatch, t)}:
                                </strong>
                            <ul>
                                {Object.keys(formik.errors).map((fieldName, index) => (
                                    <li key={index}>{formik.errors[fieldName] as string}</li>
                                ))}
                        </ul>
                    </div>
                )}

            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <button
                        ref={closeButtonRef}
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm"
                        id="kt_OffCanvas"
                        onClick={handleCloseOnClickEvent}
                    >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Cancel',dispatch, t)}
                    </button>

                    <button type="button" data-kt-element='send' className="btn btn-sm btn-primary" onClick={() => formik.handleSubmit()} disabled={!formik.isValid}>
                    {/* {t('Save')}   */}
                    {getValueFromResource('Save',dispatch, t)}
                    </button>
                </div>
            </div>

        </>

    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}


export default ExpensePolicyPerDiemForm